import ExploreProjects from "../components/common/ExploreProjects";
import SponsorBanner from "../components/common/SponserBanner";
import ProductList from "../components/product/ProductList";

const Products = () => {
  const exploreProducts = [
    "Accessibility",
    "Bathroom and Kitchen",
    "Furniture and Storage",
    "Lighting and Electrical",
    "Architectural Elements and Systems",
    "Materials and Finishes",
    "Outdoor and Landscape",
    "Plumbing and HVAC",
    "Technology and Equipment",
    "Hardware and Fixtures",
    "Miscellaneous",
  ];
  return (
    <>
      <div className="lg:px-40">
        <ProductList />
      </div>
      <div className="bg-gray-100 py-5 lg:px-40">
        <ExploreProjects title={"Explore Products"} explore={exploreProducts} />
      </div>
      <div className="lg:px-40">
        <SponsorBanner />
      </div>
    </>
  );
};

export default Products;
